(function () {
  'use strict'

  var MODULE_NAME = 'thismoment.sdk.core'

  require('./common/scss/main.scss')

  var apiCheck = require('api-check')
  apiCheck.globalConfig.disabled = true

  require('angular')
    .module(MODULE_NAME, [])

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/sdk.js